// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__XQhct","subheader":"ReorderModal_subheader__4_dY2","listWrap":"ReorderModal_listWrap__3eSCo"};